var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.85 14.85C16.35 13.35 17.25 11.325 17.25 9C17.25 4.425 13.575 0.75 9 0.75C6.75 0.75 4.65 1.65 3.15 3.15C1.65 4.65 0.75 6.75 0.75 9C0.75 13.575 4.425 17.25 9 17.25C11.25 17.25 13.35 16.35 14.85 14.85ZM15.75 9C15.75 10.575 15.225 12.075 14.25 13.2L4.8 3.75C5.925 2.775 7.425 2.25 9 2.25C12.75 2.25 15.75 5.25 15.75 9ZM3.75 4.8C2.775 5.925 2.25 7.425 2.25 9C2.25 12.75 5.25 15.75 9 15.75C10.575 15.75 12.075 15.15 13.2 14.25L3.75 4.8Z",
    fill: "#D95945"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8857_60199",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.85 14.85C16.35 13.35 17.25 11.325 17.25 9C17.25 4.425 13.575 0.75 9 0.75C6.75 0.75 4.65 1.65 3.15 3.15C1.65 4.65 0.75 6.75 0.75 9C0.75 13.575 4.425 17.25 9 17.25C11.25 17.25 13.35 16.35 14.85 14.85ZM15.75 9C15.75 10.575 15.225 12.075 14.25 13.2L4.8 3.75C5.925 2.775 7.425 2.25 9 2.25C12.75 2.25 15.75 5.25 15.75 9ZM3.75 4.8C2.775 5.925 2.25 7.425 2.25 9C2.25 12.75 5.25 15.75 9 15.75C10.575 15.75 12.075 15.15 13.2 14.25L3.75 4.8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8857_60199)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#D95945"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/DeactivateIcon.bee4d5608832f38a1d99e73ab46939e8.svg";
export { ForwardRef as ReactComponent };